// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"401":"02bd4c4a","524":"15d8f6a5","719":"d1c90959","978":"2d9fa2b5"}[chunkId] + ".chunk.js";
};